/**
 * A global registry for resolved feature flags.
 *
 * Flags are stored as a map of flag name → string value ("true"/"false").
 * Only resolved flags are stored — if a flag is not in the map, it is unknown
 * and no header should be sent for it.
 *
 * Usage:
 *   FeatureFlagRegistry.set("testFeatureFlag", true);
 *   FeatureFlagRegistry.getHeaders(); // { "X-Feature-testFeatureFlag": "true" }
 */

const resolvedFlags = new Map<string, string>();

export const FeatureFlagRegistry = {
  /**
   * Register a resolved flag value.
   */
  set(flagName: string, value: boolean): void {
    resolvedFlags.set(flagName, String(value));
  },

  /**
   * Remove a flag (e.g. if it becomes unknown again).
   */
  remove(flagName: string): void {
    resolvedFlags.delete(flagName);
  },

  /**
   * Get the value of a specific flag, or undefined if not resolved.
   */
  get(flagName: string): string | undefined {
    return resolvedFlags.get(flagName);
  },

  /**
   * Build a Record of HTTP headers for all resolved flags.
   * Each flag "foo" produces header "X-Feature-foo".
   */
  getHeaders(): Record<string, string> {
    const headers: Record<string, string> = {};
    resolvedFlags.forEach((value, name) => {
      headers[`X-Feature-${name}`] = value;
    });
    return headers;
  },
};

